__turbopack_context__.v({
  "border": "CsE_9q_border",
  "container": "CsE_9q_container",
});
